export function arrayCross(array1, array2) {
    return array1.filter(Set.prototype.has, new Set(array2));
}

export function destroyComponentInstance(instance) {
    instance.$children.forEach(children => destroyComponentInstance(children));
    instance.$destroy();
}

export function commentVNode(el, vnode) {
    const comment = document.createComment(" ");

    Object.defineProperty(comment, "setAttribute", {
        value: () => undefined
    });

    vnode.text = " ";
    vnode.elm = comment;
    vnode.isComment = true;
    vnode.context = undefined;
    vnode.tag = undefined;
    vnode.data.directives = undefined;
    vnode.children = null;

    if (vnode.componentInstance) {
        vnode.componentInstance.$el = comment;

        destroyComponentInstance(vnode.componentInstance);
    }

    if (el.parentNode) {
        el.parentNode.replaceChild(comment, el);
    }
}

/**
 * Simple object check.
 * @param item
 * @returns {boolean}
 */
export function isObject(item) {
    return item && typeof item === "object" && !Array.isArray(item);
}

/**
 * Deep merge two objects.
 * @param target
 * @param ...sources
 */
export function mergeDeep(target, ...sources) {
    if (!sources.length) return target;
    const source = sources.shift();

    if (isObject(target) && isObject(source)) {
        for (const key in source) {
            if (isObject(source[key])) {
                if (!target[key]) Object.assign(target, { [key]: {} });
                mergeDeep(target[key], source[key]);
            } else {
                Object.assign(target, { [key]: source[key] });
            }
        }
    }

    return mergeDeep(target, ...sources);
}
